import { render, staticRenderFns } from "./OrderBoxServe.vue?vue&type=template&id=be6869b6&scoped=true"
import script from "./OrderBoxServe.vue?vue&type=script&lang=js"
export * from "./OrderBoxServe.vue?vue&type=script&lang=js"
import style0 from "./OrderBoxServe.vue?vue&type=style&index=0&id=be6869b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6869b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Empty: require('/drone/src/components/Empty/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default})
